import { Component, OnInit, ViewChild } from '@angular/core';
import { NewsModel } from '../../models/NewsModel';
import { ConstantsStore } from '../../core/services/constants.store';
import { NgbCarousel, NgbCarouselConfig, NgbSlideEvent } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { NewsStore } from '../../core/services/news/news.store';
import { Record } from '../news-slide/news-slide.component';
import { NewsType } from '../../models/enums/newsType';
import { NewsService } from '../../core/services/news/news.service';
import { Loader } from 'src/app/models/Helpers/loader';
import { DataStatus } from 'src/app/models/Helpers/data-status';

@Component({
  selector: 'app-carousel-dashboard',
  templateUrl: './carousel-dashboard.component.html',
  styleUrls: ['./carousel-dashboard.component.scss']
})
export class CarouselDashboardComponent implements OnInit {

  @ViewChild('host', { static: false }) host: NgbCarousel;

  activeSlide: NewsModel;
  loader = new Loader();
  dataStatus = new DataStatus();

  constructor(
    public newsStore: NewsStore,
    private newsService: NewsService,
    private router: Router,
    private config: NgbCarouselConfig,
    private constantsStore: ConstantsStore,
  ) {
    config.interval = 5000;
    config.wrap = true;
    config.keyboard = false;
    config.pauseOnHover = true;
    config.showNavigationArrows = true;
    config.showNavigationIndicators = true;
  }

  ngOnInit(): void {
      this.getNews();
  }

  private async getNews() {
    this.dataStatus.resetStatus();
    this.loader.show();

    const newsLoaded = await this.newsService.get()
      .catch(error => {
        console.log('ERROR IN CAROUSEL DASHBOARD - GET NEWS', error);
        this.dataStatus
          .setStatus('failure')
          .setAlertMessage('Errore nel caricamento delle news')
          .setAlertClasses(['cedlab-danger']);
        this.loader.hide();
      });
    if (!newsLoaded) { return; }

    if (this.newsStore.news.length > 0) {
      this.dataStatus.setStatus('success');
    } else {
      this.dataStatus
        .setStatus('info')
        .setAlertMessage('Nessuna news disponibile')
        .setAlertClasses(['cedlab-info']);
    }

    this.loader.hide();
  }

  filterNews() {
    return this.newsStore.news.filter(news => news.visibility == 1 || news.visibility == 3);
  }

  getCompleteImageUrl(news: NewsModel) {
    if (news?.newsRecords[0]?.imagePath) {
      return this.constantsStore.apiUrl + '/' + news.newsRecords[0].imagePath;
    }
  }

  isNewsTypeTable(news) {
    return news.type === NewsType.Table;
  }

  isNewsTypeVetrina(news) {
    return news.type === NewsType.Vetrina;
  }



  newsTextPreview(news: NewsModel) {
    if (news) {
      const text = news.newsRecords[0].description;
      return (text.length > 160 ? text.substring(0, 160) + '...' : text);
    }
  }


  getHeaders(news: any): string[] {
    const headers: string[] = [];
    if (news.newsRecords[0]) {
      news.newsRecords[0].newsRecordsData.forEach(d => headers.push(d.dataHeader));
    }
    return headers;
  }

  getIsinCode = (newsRecord: Record) => newsRecord.recordValues[0];

  getTableRecords(news: any): Record[] {
    const records: Record[] = [];
    news.newsRecords.forEach(record => records.push(this.getRecord(record)));
    return records;
  }

  getRecord(record: any): Record {
    const recordView: Record = {
      recordValues: [],
      description: ''
    };
    record.newsRecordsData.forEach(d => recordView.recordValues.push(d.dataValue));
    recordView.description = record.description;
    return recordView;
  }

  removeNbsp(value) {
    return value.replace(/&nbsp;/g, ' ');
  }

  goToArticle(news: NewsModel) {
    const myurl = '/menu/article?id=' + news.id;
    this.router.navigateByUrl(myurl);
  }


  goToSlide(slide) {
    this.host.select(slide);
  }

  onSlide(slideEvent: NgbSlideEvent) {
    this.activeSlide = this.newsStore.news[slideEvent.current];
  }
}
